import {Component, Injector} from '@angular/core';
import {BlogState, Store} from './state/store';
import {Blog} from './state/model';
import {EntityListComponent} from '../../components/entity-list/component';
import {FilterService} from './filter.service';
import {BlogQuery} from './state/query';
import {BlogService} from './state/service';

@Component({
  templateUrl: '../../components/entity-list/component.html',
  styleUrls: ['../../components/entity-list/component.scss']
})
export class BlogListComponent extends EntityListComponent<Blog, BlogState, Store> {

  translationDomain = 'blog';

  constructor(
    public injector: Injector,
    protected service: BlogService,
    query: BlogQuery,
    private BlogFilterService: FilterService) {
    super(injector, service, query, BlogFilterService);
  }
  canEdit(): boolean {
    return this.hasRole('ROLE_ADMIN');
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
    this.sort.sort({
      id: 'createdAt',
      start: 'desc',
      disableClear: false
    });
  }
}
